import { ISearchParameters, ITableReport } from "./TableInterfaces";
import { DropdownItem } from "./dropdownInterfaces";

export interface IPortfolioAggregateSearchParams extends ISearchParameters {}

export interface IPortfolioAggregateTableReport extends ITableReport {}

export interface IPortfolioSearchParams extends ISearchParameters {
  accountId: number;
  omsUserIds?: number[] | string[];
}

export interface IPortfolioTableReport extends ITableReport {
  userId: number;
  instrumentId: string;
  accountName: string;
  userName: string;
}
export interface IPortfolioInsTableSearchParams extends ISearchParameters {
  accountId: number;
  instrumentId: number;
}

export interface IPortfolioInsTableReport extends ITableReport {
  userId: number;
  instrumentId: string;
  accountName: string;
  userName: string;
}

export interface IDailyPortfoGraphDTO {
  userId: number;
  fromDate?: string | null;
  toDate?: string | null;
  instrumentId?: string;
}

export interface IHourlyPortfoValueGraphDTO {
  userId: number;
  instrumentId?: string | null;
  fromTime?: string | null;
  toTime?: string | null;
  date?: string | null;
}

export interface IDropdownItem extends DropdownItem {
  fullName: string;
  type: StepInstrumentType;
  contractSize: number;
}

export enum StepInstrumentType {
  Option = 1,
  Fund = 2,
  Normal = 3,
}

export interface IWalletSearchParams extends ISearchParameters {
  accountIds?: number[] | string[];
  srcWalletTypes?: number[] | string[];
  destWalletTypes?: number[] | string[];
  status?: StatusType;
}

export interface IWalletTableReport extends ITableReport {}

export interface ICreateWallet {
  userIds: string[];
  amount: number;
  desc: string;
  srcWallet: number | string;
  destWallet: number | string;
}

export interface Wallets {
  id: number;
  name: string;
  walletType: number;
  balance: number;
}
export interface IUserWalletsInfo {
  wallets: Wallets[];
  userId: number;
  userName?: string;
}
export interface ITransferResult {
  userId: number;
  isSuccessful: boolean;
  errorMessage: null | string;
  userName?: string;
}

export enum StatusType {
  Pending = 0,
  Successful = 1,
  Failed = 2,
}

export interface IGeneralViewSearchParams extends ISearchParameters {}

export interface IGeneralViewTableReport extends ITableReport {}

export interface IAssetPercentageSearchParams extends ISearchParameters {}

export interface IAssetPercentageTableReport extends ITableReport {}

export interface IMarginSearchParams extends ISearchParameters {}

export interface IMarginTableReport extends ITableReport {}

export interface IMarginConfig {
  futureEarlyRepairThreshold?: number;
  futureEarlyRepairTarget?: number;
  optionEarlyRepairThreshold?: number;
  optionEarlyRepairTarget?: number;
}

export interface IShortCoveredCallSearchParams extends ISearchParameters {}

export interface IShortCoveredCallTableReport extends ITableReport {}

export interface ICoveredSummarySearchParams extends ISearchParameters {}

export interface ICoveredSummaryTableReport extends ITableReport {
  name?: string;
}

export interface ICoveredSummaryDetailSearchParams extends ISearchParameters {
  userId: number;
  instrumentId: string;
}

export interface ICoveredSummaryDetailTableReport extends ITableReport {}

/**
 * First item of the detail response footer carries the selected user's name
 * and the selected base-symbol ticker, shown above the detail table.
 */
export interface ICoveredSummaryDetailFooter {
  userName?: string;
  ticker?: string;
}

export interface IUserPositionSummarySearchParams extends ISearchParameters {
  userId: number;
}

export interface IUserPositionSummaryTableReport extends ITableReport {}

export interface ITable2SearchParams extends ISearchParameters {
  userId: number;
  instrumentTicker: string;
}

export interface ITable2TableReport extends ITableReport {}

export interface BaseAssetVolumeConfig {
  ticker: string;
  value: number;
}

export interface RealBaseAssetVolumeConfig {
  defaultvloume: number;
  items: BaseAssetVolumeConfig[];
}

export interface CashFlowSearchParams {
  userId: number;
  date: string;
  amount: number;
}

export interface CashFlowTableReport {
  id: number;
  userId: number;
  date: string;
  datePersian: string;
  daysFromToday: number;
  amount: number;
}

export interface CreateAccountSearchParams {
  userId: number;
  openDate: string;
}

export interface CreateAccountsTableReport {
  id: number;
  openDate: string;
  openDatePersian: string;
  daysFromToday: 0;
  date: string;
}

export interface ILiquidityManagementConfig {
  withdrawStartTime: string;
  withdrawEndTime: string;
}

export interface ILiquidityManagementSearchParams extends ISearchParameters {
  userIds?: number[] | string[] | null;
}

export interface ILiquidityManagementTableReport extends ITableReport {
  connectionStatus: number;
}

export interface ILiquidityManagementRecordsSearchParams extends ISearchParameters {
  taskId?: number | null;
}

export interface ILiquidityManagementRecordsTableReport extends ITableReport {
  state: number;
}

export interface ILiquidityManagementTask {
  id?: number;
  userIds?: number[] | string[] | null;
  withdrawThreshold: number;
  equilibriumLevel: number;
  autoWithdraw: boolean;
}

export interface IMwrPeriodReturnGraph {
  userId: number;
  from: string;
  to: string;
}

export interface IInvestmentReturnSearchParams extends ISearchParameters {
  userId: number;
}

export interface IInvestmentReturnTableReport extends ITableReport {
  userId: number;
}

export interface ExcludedCalculationSymbolSearchParams {
  userId: number;
  symbol: string;
  count: number;
}

export interface ExcludedCalculationSymbolTableReport {
  id: number;
  userId: number;
  symbol: string;
  count: number;
}
